import React, { useState, useEffect } from "react";
import Banner from "../components/Banner/Banner";
import Header from "../../layouts/Header/Header";
import ProductList from "../components/ProductList/ProductList.js";
import Footer from "../../layouts/Footer/Footer";
import axios from "axios";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Projects = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const animationVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };
  const AnimatedSection = ({ children }) => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

    return (
      <motion.div
        ref={ref}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={animationVariants}
        transition={{ duration: 0.8 }}
      >
        {children}
      </motion.div>
    );
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          "https://estate.deltaservis.com.tr/items/list.json"
        );
        // response.data doğrudan JSON veriyi içerir
        const formattedProducts = response.data.map((item) => ({
          id: item.id,
          image: item.image,
          title: item.title,
          details: item.details,
          location: item.location,
          district: item.district,
        }));
        setProducts(formattedProducts);
      } catch (error) {
        console.error("Veri çekme hatası:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return "";
  }

  return (
    <div>
      <Header />
      <Banner effect={"parallax"} />
      <AnimatedSection>
      <ProductList products={products} />
      </AnimatedSection>
      <Footer />
    </div>
  );
};

export default Projects;
